import { render, staticRenderFns } from "./form-vincularsessao.vue?vue&type=template&id=0a4b85d9"
import script from "./form-vincularsessao.vue?vue&type=script&lang=js"
export * from "./form-vincularsessao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports